import type { MomentSlot, OnboardingAnswers } from "./types";

/**
 * i18n sub-key naming a moment in the couple's own terms: a baptism-only
 * "religious" slot is the baptism ceremony; a wedding+baptism held together
 * is "Cununia religioasă și Botezul".
 */
export function momentKey(
  slot: MomentSlot,
  answers: Pick<OnboardingAnswers, "type" | "combined">,
): "civil" | "religious" | "religiousBaptism" | "together" | "baptism" | "party" {
  if (slot !== "religious") return slot;
  if (answers.type === "baptism") return "religiousBaptism";
  if (answers.type === "wedding_baptism" && answers.combined === "together") return "together";
  return "religious";
}
